import {Component, OnInit, HostListener, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators, NgForm, FormGroupDirective, FormControl} from '@angular/forms';
import {first} from 'rxjs/operators';

import {AlertService} from '../../services/alert.service';
import {ErrorStateMatcher} from '@angular/material/core';
import {MessageService} from '../../services/message.service';
import {RECAPTCHA_URL} from '../../directives/recaptcha.directive';
import {formatDate, DatePipe} from '@angular/common';
import {
    ConfirmValidParentMatcher,
    OapStandarErrorStateMatcher,
    regExps,
    errorMessages,
    OapErrorMessages,
    CustomValidatorsModule
} from '../../modules/custom-validators/custom-validators.module';
import {AppConfigService} from '../../services/app-config.service';

import {DateAdapter} from '@angular/material/core';
import {JJMMYYYY_FORMAT_PROVIDER} from '../../helpers/jjmmyyy-format.helper';

import {TrackingService} from '../../services/tracking.service';
import {environment} from '../../../environments/environment';
import {sourceMailInformationEnum} from '../../models/sourceMailInformation.enum';
import {CompteService} from '../../services/compte.service';

export class RegisterErrorStateMatcherComponent implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}

@Component({
    selector: 'oap-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    providers: [{
        provide: RECAPTCHA_URL,
        useValue: 'http://localhost:3000/validate_captcha'
    }, ...JJMMYYYY_FORMAT_PROVIDER
    ]
})

export class RegisterComponent implements OnInit, OnDestroy {
    registerForm: FormGroup;
    loading = false;
    submitted = false;

    errors = errorMessages;

    register_validation_messages = OapErrorMessages;

    minDate = new Date(1900, 0, 1);
    maxDate: Date = new Date(formatDate(Date.now(), 'MM/dd/yyyy', 'en'));

    matcher = new OapStandarErrorStateMatcher();
    confirmValidParentMatcher = new ConfirmValidParentMatcher();

    siteKey: string;

    public mask = [/[1-4,7-8]/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /[0-9A-B]/, ' ',
        /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/];
    public maskTel = [/\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/];

    constructor(
        private _appConfig: AppConfigService,
        private formBuilder: FormBuilder,
        private router: Router,
        private alertService: AlertService,
        private adapter: DateAdapter<any>,
        private messageService: MessageService,
        private tracking: TrackingService,
        private compteService: CompteService) {
    }

    ngOnInit() {
        this.alertService.clear();

        //
        this.messageService.sendMessage('page-register');
        this.siteKey = this._appConfig.config.reCaptchaSiteKey;

        if (!environment.production && !environment.preprod) {
            this.siteKey = '6Levgq8UAAAAACarJKYgQEbcMphFaXlbUlThZkmS';
        }
        this.adapter.setLocale('fr');

        this.registerForm = this.formBuilder.group({
            lastName: ['', [Validators.required,
                Validators.maxLength(40),
                Validators.pattern(regExps.onlyLetters)]],
            firstName: ['', [Validators.required,
                Validators.maxLength(40),
                Validators.pattern(regExps.onlyLettersAccent)]],
            birthday: ['', Validators.required],
            mobile: ['', [CustomValidatorsModule.maskMinValidator(10),
                Validators.required]],
            matchingEmails: this.formBuilder.group({
                email: ['', [Validators.required,
                    Validators.minLength(5),
                    Validators.maxLength(256),
                    Validators.email]],
                emailConf: ['', Validators.required]
            }, {
                validator: (formGroup: FormGroup) => {
                    const ret = CustomValidatorsModule.areEqual(formGroup);
                    // console.log('validator matchingEmails : ' + ret);
                    return ret;
                }
            }),
            newsletter: [''],
            captcha: ['', Validators.required],
        });

        const element = document.getElementById('scrollWrapper');
        element.classList.add('wrapperLogged');

        this.tracking.DataLayer('/app/register', 'Inscription', '', '');

    }

    ngOnDestroy() {
        const element = document.getElementById('scrollWrapper');
        element.classList.remove('wrapperLogged');
    }

    @HostListener('window:keyup.enter', ['$event', 'undefined'])
    @HostListener('window:click', ['undefined', '$event'])
    onEnterOrClick() {
        this.alertService.clear();
    }


    onSubmit(form: FormGroup) {

        this.submitted = true;

        if (this.registerForm.invalid) {
            return;
        }
        let mobile: string = form.controls.mobile.value;
        mobile = mobile ? mobile.replace(/\s/g, '') : null;

        this.loading = true;

        const datePipe = new DatePipe('en');
        const sourceMailInformation = sourceMailInformationEnum.PORTAIL;

        const registerRequest = {
            firstName: form.controls.firstName.value,
            lastName: form.controls.lastName.value,
            birthday: datePipe.transform(form.controls.birthday.value, 'yyyy-MM-dd'),
            email: form.controls.matchingEmails.value.email,
            mobile: mobile,
            accepteNewletters: form.controls.newsletter.value,
            sourceMailInformation: sourceMailInformation
        };

        this.compteService.register(registerRequest)
            .pipe(first())
            .subscribe(
                data => {
                    this.alertService.success('Inscription réussie. Vous allez recevoir un mail de confirmation.', true);
                    this.tracking.pushDataLayer('Creation de compte', 'Click', 'Inscription valide');
                    this.router.navigate(['/login']);
                },
                error => {
                    this.alertService.error(error, true);
                    this.tracking.pushDataLayer('Creation de compte', 'Click', 'Inscription invalide');

                    console.error(error);
                    this.loading = false;
                });
    }
}
